import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseEntity, BaseState, SystemOptionEntity } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { Component, ViewChild } from '@angular/core';
import { AppConfigService } from '@m4u-angular/configuration/app.config.service';
import { EnumMessageBoxTypes, EnumSystemOptionDataTypes, EnumSystemOptions } from '@m4u-angular/core/framework/sysenums.enum';
import { AddSystemOptionDialogComponent } from './Components/add-system-option-dialog/add-system-option-dialog.component';
import { Utils } from '@m4u-angular/core/helpers/Utils';
import { SystemOptionsListComponent } from './Components/system-options-list/system-options-list.component';
import { MessageBoxDialogComponent } from '@m4u-angular/ui/dialogs/messagebox-dialog/messageboxdialog.component';

class State extends BaseState {
    GeneralOptions: SystemOptionEntity[];
    CustomOptions: SystemOptionEntity[];

    ModulesDataSource: any[];
    CurrentTabIndex: number = 0;
    Tabs: any[] = [];
    CustomSections: string[] = [];
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-system-options',
    templateUrl: './system-options.component.html',
    styleUrls: ['./system-options.component.scss']
})
export class SystemOptionsComponent extends BasePageComponent<BaseEntity, State> {
    private GeneralOptionSettings = {
        [EnumSystemOptions.AppNameHE]: { DataType: EnumSystemOptionDataTypes.String, SectionName: 'General', SectionIndex: 0, DefaultIsClient: true },
        [EnumSystemOptions.AppNameEN]: { DataType: EnumSystemOptionDataTypes.String, SectionName: 'General', SectionIndex: 0, DefaultIsClient: true },
        [EnumSystemOptions.AppURL]: { DataType: EnumSystemOptionDataTypes.String, SectionName: 'General', SectionIndex: 0, DefaultIsClient: true },

        [EnumSystemOptions.SessionTimeout]: { DataType: EnumSystemOptionDataTypes.Number, SectionName: 'Framework', SectionIndex: 1, DefaultIsClient: true },
        [EnumSystemOptions.SessionExpiry]: { DataType: EnumSystemOptionDataTypes.Number, SectionName: 'Framework', SectionIndex: 1, DefaultIsClient: true },
        [EnumSystemOptions.EnableRequestLogging]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Framework', SectionIndex: 1, DefaultIsClient: false },
        [EnumSystemOptions.EnableRemoteLogging]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Framework', SectionIndex: 1, DefaultIsClient: false },
        [EnumSystemOptions.ShowExpiredTimeoutAlert]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Framework', SectionIndex: 1, DefaultIsClient: true },
        [EnumSystemOptions.ShowAlmostExpiredTimeoutAlert]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Framework', SectionIndex: 1, DefaultIsClient: true },

        [EnumSystemOptions.IsSupportedCredentialsManagement]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Login', SectionIndex: 2, DefaultIsClient: false },
        [EnumSystemOptions.IsSupportedUserWelcome]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Login', SectionIndex: 2, DefaultIsClient: false },
        [EnumSystemOptions.IsSupportedPasswordChange]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Login', SectionIndex: 2, DefaultIsClient: true },
        [EnumSystemOptions.IsSupportedPasswordRecovery]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Login', SectionIndex: 2, DefaultIsClient: true },
        [EnumSystemOptions.IsSupportedLoginByOTP]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Login', SectionIndex: 2, DefaultIsClient: true },
        [EnumSystemOptions.IsSupportedLoginByPassword]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Login', SectionIndex: 2, DefaultIsClient: true },
        [EnumSystemOptions.IsAutoCreateCredentials]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Login', SectionIndex: 2, DefaultIsClient: false },
        [EnumSystemOptions.AutoCreateCredentialsType]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Login', SectionIndex: 2, DefaultIsClient: true },
        [EnumSystemOptions.IsRequireTaxNumberForOTP]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Login', SectionIndex: 2, DefaultIsClient: true },

        [EnumSystemOptions.PasswordChangeIntervalDays]: { DataType: EnumSystemOptionDataTypes.Number, SectionName: 'Password', SectionIndex: 3, DefaultIsClient: true },
        [EnumSystemOptions.PasswordComplexityLen]: { DataType: EnumSystemOptionDataTypes.Number, SectionName: 'Password', SectionIndex: 3, DefaultIsClient: true },
        [EnumSystemOptions.PasswordComplexityMinChars]: { DataType: EnumSystemOptionDataTypes.Number, SectionName: 'Password', SectionIndex: 3, DefaultIsClient: true },
        [EnumSystemOptions.PasswordComplexityMinDigits]: { DataType: EnumSystemOptionDataTypes.Number, SectionName: 'Password', SectionIndex: 3, DefaultIsClient: true },

        [EnumSystemOptions.BadLoginAttemptBeforeLock]: { DataType: EnumSystemOptionDataTypes.Number, SectionName: 'BadLogin', SectionIndex: 4, DefaultIsClient: false },
        [EnumSystemOptions.BadLoginAttemptsCheckIntervalMinutes]: { DataType: EnumSystemOptionDataTypes.Number, SectionName: 'BadLogin', SectionIndex: 4, DefaultIsClient: false },
        [EnumSystemOptions.BadLoginAttemptLockouIntervalMinutes]: { DataType: EnumSystemOptionDataTypes.Number, SectionName: 'BadLogin', SectionIndex: 4, DefaultIsClient: false },

        [EnumSystemOptions.XFrameOptions]: { DataType: EnumSystemOptionDataTypes.String, SectionName: 'Framework', SectionIndex: 1, DefaultIsClient: false },
        [EnumSystemOptions.IsDeployedBehindLoadBalancer]: { DataType: EnumSystemOptionDataTypes.Boolean, SectionName: 'Framework', SectionIndex: 1, DefaultIsClient: false },

    };

    @ViewChild(AddSystemOptionDialogComponent) addGeneralOptionDialog: AddSystemOptionDialogComponent;
    @ViewChild(SystemOptionsListComponent) systemOptionsList: SystemOptionsListComponent;
    @ViewChild(MessageBoxDialogComponent) messageDialog: MessageBoxDialogComponent;

    constructor(A: ServiceBagService, private appConfigService: AppConfigService) {
        super(A, 'SystemOptionsComponent', BaseEntity, State);
    }

    override OnInitComponent() {
        this.InitTabs();
        this.InitModulesDataSource();
        this.InitSystemOptions();
    }

    OnClickAdd() {
        this.addGeneralOptionDialog.ShowDialogShort((option: SystemOptionEntity) => {

            if (this.State.CurrentTabIndex === 0) {
                this.AddGeneralOption(option);
            } else {
                this.AddCustomOption(option);
            }

            this.systemOptionsList.ShowOption(option);
        });
    }

    OnSaveOptions() {
        for (let i = 0; i < this.State.GeneralOptions.length; i++) {
            if (this.State.GeneralOptions[i].DataType === EnumSystemOptionDataTypes.Boolean) {
                this.State.GeneralOptions[i].Value = this.State.GeneralOptions[i].ValueBoolean ? '1' : '0';
            } else if (this.State.GeneralOptions[i].DataType === EnumSystemOptionDataTypes.Number) {
                this.State.GeneralOptions[i].Value = this.State.GeneralOptions[i].ValueNumber.toString();
            }

            if (Utils.IsEmpty(this.State.GeneralOptions[i].Value)) {
                this.State.CurrentTabIndex = 0;
                setTimeout(() => {
                    this.systemOptionsList.ShowOption(this.State.GeneralOptions[i]);
                    this.UI.StopMessage(this.RC('msgOptionEmpty').replace('{0}', this.State.GeneralOptions[i].OptionName));
                });

                return;
            }
        }

        for (let i = 0; i < this.State.CustomOptions.length; i++) {
            if (Utils.IsEmpty(this.State.CustomOptions[i].Value)) {
                setTimeout(() => {
                    this.State.CurrentTabIndex = 1;
                    this.systemOptionsList.ShowOption(this.State.CustomOptions[i]);
                    this.UI.StopMessage(this.RC('msgOptionEmpty').replace('{0}', this.State.GeneralOptions[i].OptionName));
                });

                return;
            }
        }

        this.Do(this.A.Framework.systemEndpoint.SaveOptions(this.State.GeneralOptions.concat(this.State.CustomOptions)), true, (response) => {
            window.location.reload();
        });
    }

    OnDeleteOption(option: SystemOptionEntity) {
        this.messageDialog.Type = EnumMessageBoxTypes.YesNo;

        this.messageDialog.ShowDialogShort(() => {
            option.IsDeleted = true;
        });

        this.messageDialog.Title = this.RC('titleDelete');
        this.messageDialog.Prompt = this.RC('msgRemoveOption').replace('{0}', option.OptionName);
    }

    private InitSystemOptions() {
        this.Do(this.A.Framework.systemEndpoint.GetOptions(), false, (response) => {
            this.State.GeneralOptions = [];
            this.State.CustomOptions = [];

            let settings;

            response.Entities.forEach((x) => {
                x.ModuleName = x.ModuleName ? x.ModuleName : null;

                settings = this.GeneralOptionSettings[x.OptionName];

                if (!settings) {
                    this.State.CustomOptions.push(x);

                    if (this.State.CustomSections.indexOf(x.SectionInfo) < 0) {
                        this.State.CustomSections.push(x.SectionInfo);
                    }
                } else {
                    x.SectionInfo = settings.SectionName;
                    x.SectionIndex = settings.SectionIndex;
                    x.DataType = settings.DataType;
                    x.DefaultIsClient = settings.DefaultIsClient;

                    if (settings.DataType === EnumSystemOptionDataTypes.Number) {
                        x.ValueNumber = parseInt(x.Value, 10);
                    } else if (settings.DataType === EnumSystemOptionDataTypes.Boolean) {
                        x.ValueBoolean = x.Value === '1' ? true : false;
                    }

                    this.State.GeneralOptions.push(x);
                }

            });
        });
    }

    private InitModulesDataSource() {
        const modules = this.appConfigService.AppConfig.ModuleName.split(',');

        // Add first empty item
        this.State.ModulesDataSource = [];
        this.State.ModulesDataSource.push({
            Text: 'All',
            Value: undefined
        });

        for (let i = 0; i < modules.length; i++) {
            this.State.ModulesDataSource.push({
                Text: modules[i],
                Value: modules[i]
            });
        }
    }

    private InitTabs() {
        this.State.Tabs = [
            {
                index: 0,
                text: this.RC('lblGeneral')
            }, {
                index: 1,
                text: this.RC('lblCustom')
            }
        ];
    }

    private AddGeneralOption(option: SystemOptionEntity) {
        if (this.State.GeneralOptions.find(x => x.OptionName === option.OptionName && x.ModuleName === option.ModuleName)) {
            this.UI.UnexpectedMessage(this.RC('msgOptionAlreadyExists'));
        } else {
            const settings = this.GeneralOptionSettings[option.OptionName];

            option.IsClient = settings.DefaultIsClient;
            option.DataType = settings.DataType;
            option.SectionInfo = settings.SectionName;
            option.SectionIndex = settings.SectionIndex;

            if (option.DataType === EnumSystemOptionDataTypes.Boolean) {
                option.ValueBoolean = false;
            } else if (option.DataType === EnumSystemOptionDataTypes.Number) {
                option.ValueNumber = 0;
            }

            const options = Utils.CloneObject(this.State.GeneralOptions);
            options.push(option);

            this.State.GeneralOptions = options;
        }
    }

    private AddCustomOption(option: SystemOptionEntity) {
        if (this.State.CustomOptions.find(x => x.OptionName === option.OptionName && x.ModuleName === option.ModuleName)) {
            this.UI.UnexpectedMessage(this.RC('msgOptionAlreadyExists'));
        } else {

            option.IsClient = true;
            option.IsServer = true;

            const options = Utils.CloneObject(this.State.CustomOptions);
            options.push(option);

            this.State.CustomOptions = options;

            if (this.State.CustomSections.indexOf(option.SectionInfo) < 0) {
                this.State.CustomSections.push(option.SectionInfo);
            }
        }
    }
}

